<template>
    <div id="category_list_section"
        v-if="isLoaded && isHaveItem">
        <HomeCategorySlide
            :category="ambassadorCategory"
            :isAmbassadorCategory="true"
            :trackingService="trackingService" />
        <div id="category_list">
            <HomeCategorySlide
                v-for="(category, k) in categories"
                :key="k"
                :category="category"
                :trackingService="trackingService" />
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
//helper
import Account from '@/helper/AccountHelper.js'
//mixin
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
// component
import HomeCategorySlide from './HomeCategorySlide.vue';
//core
import { CategoryConfigBuilder } from '@/core/Campaign/model/CategoryConfigModel.js';
import RewardService from '@/core/Custom/service/RewardService';
export default {
    name: 'HomeCategory',
    mixins: [ErrorApiMixin],
    components: {
        HomeCategorySlide
    },
    props: {
        ambassadorCatId: { type: String },
        modalController: { type: Object },
        trackingService: { type: Object }
    },
    computed: {
        tier: function () {
            return this.$store.state.tier;
        },
        theme: function () {
            return this.$store.state.theme;
        },
        isAmbassador: function () {
            return this.$store.state.isAmbassador;
        },
        isHaveItem: function () {
            return this.categories.length > 0
        }
    },
    data: function () {
        return {
            isLoaded: false,
            ambassadorCategory: {},
            categories: [],
        };
    },
    created: function () {
        this.initialMenuCategory();
        this.errorHandler.setAlertModal(this.modalController.alertModal);
        this.errorHandler.setNoInternetModal(this.modalController.noInternetModal);
    },
    methods: {
        //callback
        apiLoaded: function () {
            this.$emit('apiLoaded', { 'api': 'menucategory'});
        },
        //initial
        initialMenuCategory: function () {
            var categoryName;
            if (this.tier == 'm') {
                categoryName = this.isAmbassador
                    ? Vue.bzbsConfig.categoryConfig.mass_am
                    : Vue.bzbsConfig.categoryConfig.mass;
            } else {
                categoryName = this.isAmbassador
                    ? Vue.bzbsConfig.categoryConfig.prestige_am
                    : Vue.bzbsConfig.categoryConfig.prestige;
            }

            var menuCategoryConfig = new CategoryConfigBuilder()
                .setConfig(categoryName)
                .create();

            var token = Account.getToken();
            RewardService.apiGetCategory(token, menuCategoryConfig.getParams())
                .then(res => {
                    if (this.ambassadorCatId && this.isAmbassador) {
                        var filteredCate = res.filter(category => {
                            if (category.id == this.ambassadorCatId)
                                this.ambassadorCategory = category;

                            return (category.id != this.ambassadorCatId)
                        });

                        this.categories = [...filteredCate]
                    } else {
                        this.categories = [...res];
                    }

                    this.isLoaded = true;
                    this.apiLoaded();
                }).catch(err => {
                    this.isLoaded = true;
                    this.isHaveItem = false;
                    this.errorApi(err, this.errorHandler);
                });
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
#category_list_section {
    padding: {
        bottom: 10px;
    }
}
</style>
